import { z } from 'zod';

const StreamUrlResponseSchema = z.object({
    url: z.string(),
});

export type StreamUrlResponseType = z.infer<typeof StreamUrlResponseSchema>;

const StreamMetaDataSchema = z.object({
    bitrateLevel: z.string(),
    mediaFormat: z.string(),
    url: z.string(),
});

const StreamUrlsResponseSchema = z.object({
    streams: z.array(StreamMetaDataSchema).nullable(),
});

export type StreamUrlsResponseType = z.infer<typeof StreamUrlsResponseSchema>;

export const RmgMetadataResponseSchema = z.object({
    fixtureId: z.string(),
    assetId: z.string(),
    accessToken: z.string(),
    outletAuthKey: z.string(),
    accountId: z.number(),
});

export type RmgStreamMetadataResponseType = z.infer<typeof RmgMetadataResponseSchema>;

export const GeniusAvailabilitySchema = z.enum([
    'AVAILABLE',
    'DISABLED',
    'UNMATCHED',
    'UNBOOKED',
    'NOT_IN_PLAY',
    'NO_LIVE_STREAM',
    'DELIVERY_UNAVAILABLE',
    'FORBIDDEN',
]);

export type GeniusAvailabilityType = z.infer<typeof GeniusAvailabilitySchema>;

export const GeniusDeliveryProtocolSchema = z.enum(['HLS', 'DASH']);

export type GeniusDeliveryProtocolType = z.infer<typeof GeniusDeliveryProtocolSchema>;

export const GeniusDeviceSchema = z.enum(['MOBILE', 'TABLET', 'DESKTOP', 'OTT']);

export type GeniusDeviceType = z.infer<typeof GeniusDeviceSchema>;

const GeniusStreamPermissionSchema = z.object({
    region: z.string(),
    device: z.string(),
    maxPlayerSizePercentage: z.number().optional(),
});

const GeniusDeliveryOptionSchema = z.object({
    protocol: z.string(),
    deliveryId: z.string(),
});

const GeniusLiveStreamSchema = z.object({
    streamId: z.string(),
    permissions: z.array(GeniusStreamPermissionSchema).optional(),
    dmas: z.array(z.unknown()).optional(),
    deliveries: z.array(GeniusDeliveryOptionSchema),
});

export const GeniusMetadataResponseSchema = z.object({
    available: z.boolean(),
    availability: GeniusAvailabilitySchema,
    fixtureId: z.string().nullable().optional(),
    phase: z.string().optional(),
    bookingStatus: z.string().optional(),
    glpWidgetUrl: z.string().optional(),
    customerId: z.string().optional(),
    playerDigest: z.string().optional(),
    liveStreams: z.array(GeniusLiveStreamSchema).optional(),
});

export type GeniusMetadataResponseType = z.infer<typeof GeniusMetadataResponseSchema>;

export const GeniusDrmSchema = z.record(z.string()).optional();

export const GeniusDeliveryResponseSchema = z.object({
    available: z.boolean(),
    availability: GeniusAvailabilitySchema,
    url: z.string().optional(),
    token: z.string().optional(),
    expiresAt: z.string().optional(),
    drm: GeniusDrmSchema,
});

export type GeniusDeliveryResponseType = z.infer<typeof GeniusDeliveryResponseSchema>;

export const GeniusDeliveryRequestSchema = z.object({
    eventId: z.number(),
    streamId: z.string(),
    protocol: GeniusDeliveryProtocolSchema,
    deliveryId: z.string(),
    endUserSessionId: z.string(),
    region: z.string(),
    device: GeniusDeviceSchema,
});

export type GeniusDeliveryRequestType = z.infer<typeof GeniusDeliveryRequestSchema>;
